export const filterIconButtonStyles = {
  padding: '2px',
  opacity: 0,
  transition: 'opacity 0.2s ease, color 0.2s ease',

  '&.filter-active': {
    opacity: 1,
    color: 'primary.main',
  },
};

export const popoverSlotProps = {
  paper: {
    sx: {
      borderRadius: '8px',
      boxShadow: ({ shadows }) => shadows[4],
      minWidth: '280px',
    },
  },
};

export const anchorOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

export const transformOrigin = {
  vertical: 'top',
  horizontal: 'left',
};

export const dateRangeContentStyles = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
  px: 2,
  pt: 2,
};

export const dateRangeFieldStyles = {
  width: '140px',
  '& .MuiInputBase-root': {
    height: '40px',
  },
};

export const dateRangeSeparatorStyles = {
  mx: 0.5,
};

export const menuControlStyles = {
  flexDirection: 'row',
  gap: 1,
  justifyContent: 'flex-end',
  p: 2,
  paddingTop: 1,
};
